// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MnTp","label":"styles_label__pBl7B"};